export default __webpack_public_path__ + "static/media/Nitroxgallery_91.7ace3f47.webp";